import * as ordreTravailAffichage from '@/i18n/fr/logistique/ordreTravail/ordreTravailAffichage';
import FACE_DISPO from '@/i18n/fr/logistique/faceDisponible';
import { LISTE_DEMANDE_INTERVENTION, EDITION_INTERVENTION, DETAIL_INTERVENTION } from '@/i18n/fr/logistique/intervention/intervention';
import * as ordreTravailTech from '@/i18n/fr/logistique/ordreTravail/ordreTravailTechnique';
import * as projet from '@/i18n/fr/logistique/projets/projets';
import RESTRICTION from '@/i18n/fr/logistique/restriction/restriction';
import LISTE_TECHNICIEN from '@/i18n/fr/logistique/technicien/technicien';
import * as typeOt from '@/i18n/fr/logistique/typeOt/typeOt';
import * as audit from '@/i18n/fr/logistique/audit/audit';
import * as bonExpedition from '@/i18n/fr/logistique/ordreTravail/bonExpedition';
import LISTE_CHARGE_TRAVAIL_TECHNIQUE
  from '@/i18n/fr/logistique/chargeTravail/technique/chargeTravail';
import LISTE_DEMANDE from './demande/demande';
import DEMANDE_LOGISTIQUE from './demande/demandeLogistique';
import * as tourneeModele from './tourneeModele/tourneeModele';
import AFFECTATION from './affectation/affectation';
import LISTE_AFFICHEUR from './afficheur/afficheur';
import LISTE_CHARGE_TRAVAIL_AFFICHAGE from './chargeTravail/affichage/chargeTravail';
import PREVISIONNEL_DEPART from './previsionnelDepart/previsionnel';
import LISTE_EXPEDITIONS, { POP_UP_CHANGER_ETAT_EXPEDITION } from './ordreTravail/expeditions';
import LISTE_OT_IMPRESSION from './ordreTravail/ordreTravailImpression';
import SUIVI_PRODUCTION from './suiviProduction';

const LOGISTIQUE = {
  listeTourneeModele: tourneeModele.LISTE_TOURNEE_MODELE,
  addEditTourneeModele: tourneeModele.ADD_EDIT_TOURNEE_MODELE,
  listeAfficheur: LISTE_AFFICHEUR,
  detailTourneeModele: tourneeModele.DETAIL_TOURNEE_MODELE,
  listeDemande: LISTE_DEMANDE,
  demandeLogistique: DEMANDE_LOGISTIQUE,
  chargeTravailAff: LISTE_CHARGE_TRAVAIL_AFFICHAGE,
  chargeTravailTech: LISTE_CHARGE_TRAVAIL_TECHNIQUE,
  gestionAffectation: AFFECTATION,
  listeOrdreTravailAffichage: ordreTravailAffichage.LISTE_ORDRE_TRAVAIL_AFFICHAGE,
  listeExpedition: LISTE_EXPEDITIONS,
  popupChangerEtatExpedition: POP_UP_CHANGER_ETAT_EXPEDITION,
  detailOrdreTravailAffichage: ordreTravailAffichage.DETAIL_ORDRE_TRAVAIL_AFFICHAGE,
  modificationOrdreTravailAffichage: ordreTravailAffichage.MODIFICATION_ORDRE_TRAVAIL_AFFICHAGE,
  affectationOrdreTravailAffichage: ordreTravailAffichage.AFFECTATION_ORDRE_TRAVAIL_AFFICHAGE,
  restriction: RESTRICTION,
  faceDisponible: FACE_DISPO,
  editionIntervention: EDITION_INTERVENTION,
  listeIntervention: LISTE_DEMANDE_INTERVENTION,
  detailIntervention: DETAIL_INTERVENTION,
  listeOrdreTravailTech: ordreTravailTech.LISTE_ORDRE_TRAVAIL_TECH,
  detailOrdreTravailTech: ordreTravailTech.DETAIL_ORDRE_TRAVAIL_TECH,
  addEditOrdreTravailTech: ordreTravailTech.ADD_ORDRE_TRAVAIL_TECH,
  listeTechnicien: LISTE_TECHNICIEN,
  listeTypeOt: typeOt.LISTE_TYPE_OT,
  detailTypeOt: typeOt.DETAIL_TYPE_OT,
  addEditTypeOt: typeOt.ADD_EDIT_TYPE_OT,
  listeProjets: projet.LISTE_PROJETS,
  editionProjet: projet.EDITION_PROJET,
  previsionnelDepart: PREVISIONNEL_DEPART,
  listeAudit: audit.LISTE_AUDIT,
  detailAudit: audit.DETAIL_AUDIT,
  addEditAudit: audit.ADD_EDIT_AUDIT,
  listeOtImpression: LISTE_OT_IMPRESSION,
  suiviProduction: SUIVI_PRODUCTION,
  detailBonExpedition: bonExpedition.DETAIL_BON_EXPEDITION,
  editBonExpedition: bonExpedition.EDIT_BON_EXPEDITION,
  listBonExpedition: bonExpedition.LIST_BON_EXPEDITION,
};

export default LOGISTIQUE;
